export default "/images/bf6d7a8a8416d9baba5f53a49a959161.avif";